import { useState, useEffect } from 'react'
import { Button, Input, ColorPicker, Dropdown } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { pickerFonts } from '@messenger/lotus/fonts'
import { useErrorHandler } from 'hooks/utility/useErrorHandler'
import { useTranslation } from 'react-i18next'
import { DEFAULT_FONT_COLOR } from '@messenger/consts'
import { DEFAULT_FONT_FAMILY } from '@messenger/lotus/fonts'
import { updateCustomTheme } from '@/api/customThemes'

export const NewThemeModal = ({ setShowNewThemeModal, createTheme, theme }) => {
  const { t } = useTranslation()
  const handleError = useErrorHandler('NewThemeModal')
  const [themeName, setThemeName] = useState('')
  const [color, setColor] = useState(DEFAULT_FONT_COLOR)
  const [font, setFont] = useState(DEFAULT_FONT_FAMILY)

  const save = async () => {
    try {
      const payload = {
        name: themeName,
        font_color: color,
        font: font,
      }
      if (!theme?.id) {
        createTheme(payload)
      } else {
        await updateCustomTheme(theme.id, payload)
      }
      setShowNewThemeModal(false)
    } catch (error) {
      handleError(error?.response?.data?.message || error.message, error)
    }
  }

  useEffect(() => {
    if (theme?.id) {
      setThemeName(theme.name)
      setFont(theme.font)
      setColor(theme.font_color)
    }
  }, [theme])
  return (
    <Flex
      column
      padding="32px"
      width="500px"
      height="500px"
      justify="space-between"
      overflow-y="auto"
    >
      <Flex column>
        <Text size="24px" weight="600" margin="0 0 20px 0">
          {t('newThemeModal.title')}
        </Text>
        <Input
          full
          label={t('newThemeModal.themeName')}
          placeholder={t('newThemeModal.themeName')}
          value={[themeName, setThemeName]}
          margin="0 0 24px 0"
        />
        <Dropdown
          selected={[font, setFont]}
          placeholder={t('newThemeModal.fonts')}
          textKey="name"
          valueKey="name"
          label={t('newThemeModal.fonts')}
          items={pickerFonts}
          fontMenu={true}
          margin="0 0 24px 0"
        />
        <ColorPicker
          color={[color, setColor]}
          label={t('newThemeModal.fontColor')}
          margin="0 0 24px"
        />
      </Flex>
      <Flex justify="flex-end" margin="24px 0 0 0">
        <Button margin="0 16px 0 0" onClick={() => setShowNewThemeModal(false)}>
          {t('newThemeModal.cancelButton')}
        </Button>

        <Button left primary margin="0 12px 0 0" onClick={() => save()}>
          {t('newThemeModal.saveButton')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default NewThemeModal
